import React from "react";
import styled from "styled-components";
import Arrow from "../../assets/SMSVG/SellerSvg/arrow";
import GoodPostCart from "./SmallComps/GoodPostCart";
import { GetDataPromise } from "../Functions/SendingData";
import { Loading } from "../Loading";


const StyleLaptop = styled.div`
    margin: 2rem 0 ;
    .main-pad{
        grid-column: span 1;
    }
    .main-box{
        grid-column-start: 2;
        grid-column: span 3;
        height: 100%;
        display: flex;
        flex-direction: column;
        flex-grow: 1;

    }
    .container-scroll {
        grid-column: 1/13;
        width: 100%;
        overflow-x: scroll;
        padding: 0.5rem 0;
        ::-webkit-scrollbar {
            -ms-overflow-style: none;  /* Internet Explorer 10+ */
            scrollbar-width: none;  /* Firefox */
            display: none;  /* Safari and Chrome */
        }
    } 
    .main-scroll{
        display: flex;
        flex-direction: row;
        width: 100%;
        justify-content: space-between;
        position: relative;
        -ms-overflow-style: none; 
        scrollbar-width: none; 
        ::-webkit-scrollbar {
            -ms-overflow-style: none;  /* Internet Explorer 10+ */
            scrollbar-width: none;  /* Firefox */
            display: none;  /* Safari and Chrome */
        }
        .main-box{
            width: calc(100% - 1rem);
            margin: 0 0.5rem;
            height: 100%;
            display: flex;
            flex-direction: column;
            flex-grow: 1;
        }
    }
    .arrow{
        position: absolute;
        display: flex;
        cursor: pointer;
        align-items: center;
        border: 1px solid var(--n-grey-2);
        padding: 1.5rem 1rem;
        box-shadow: 0px 4px 30px -4px rgba(0, 0, 0, 0.12);
        border-radius: 4px;
        background-color: var(--body-2);
        height: 5rem;
        z-index: 2;
        .arr{
            width: 1rem;
        }
    }
    .right{
        right: -1.5rem;
        top: 25%;
    }
    .left{
        left: -1.5rem;
        top: 25%;
        .arr{
            transform: rotate(-180deg);
        }
    }
`
const StyleMobile = styled.div`
    display: flex;
    flex-direction: row;
    overflow: hidden;
    justify-content: center;
    padding:0;
    width: 100%; 
    margin: 1.5rem 0;
    position: relative;
    .container-scroll {
        width: 100%;
        overflow-x: scroll;
        ::-webkit-scrollbar {
            -ms-overflow-style: none;  /* Internet Explorer 10+ */
            scrollbar-width: none;  /* Firefox */
            display: none;  /* Safari and Chrome */
        }
    } 
    .main-scroll{
        display: flex;
        flex-direction: row;
        width: 100%;
        justify-content: space-between;
        position: relative;
        -ms-overflow-style: none; 
        scrollbar-width: none; 
        ::-webkit-scrollbar {
            -ms-overflow-style: none;  /* Internet Explorer 10+ */
            scrollbar-width: none;  /* Firefox */
            display: none;  /* Safari and Chrome */
        }
        .main-box{
            width: calc(100% - 1rem);
            margin: 0 0.5rem;
            display: flex;
            flex-direction: column;
            flex-grow: 1;
        }
    }
    .arrow{
        position: absolute;
        display: flex;
        align-items: center;
        border: 1px solid var(--n-grey-2);
        padding: 1.5rem 1rem;
        box-shadow: 0px 4px 30px -4px rgba(0, 0, 0, 0.12);
        border-radius: 4px;
        background-color: var(--body-2);
        height: 5rem;
        z-index: 2;
        .arr{
            width: 1rem;
        }
    }
    .right{
        right: 0;
        top: 25%;
    }
    .left{
        left: 0;
        top: 25%;
        .arr{
            transform: rotate(-180deg);
        }
    }
`

class RibbonBlogPostGood extends React.Component{
   constructor(props) {
        super(props);
        this.refScroll = React.createRef()
        this.state={
            postData:[],
            sending:true,
            tag:''
        }
    }
   

    
    rightClick=()=>{
        this.refScroll.current.scrollTo({
            left: this.refScroll.current.scrollLeft + (window.innerWidth * 0.80),
            behavior: "smooth"
        })
    }
    leftClick=()=>{
        this.refScroll.current.scrollTo({
            left: this.refScroll.current.scrollLeft - (window.innerWidth * 0.80),
            behavior: "smooth"
        })
    }
    laptopRender(){
        let classname = 'main-grid'
        let pad = <div className="main-pad"></div>
        if(this.props.noPad){
            classname = "main-grid-inner"
            pad = ""
        }
        if(this.state.postData.length > 4) {
            return(
                <StyleLaptop className={classname} >
                    {pad}
                    <div className="arrow right" onClick={this.rightClick}><Arrow/></div>
                    <div className="container-scroll" ref={this.refScroll}>
                        <div className="main-scroll" style={{width: (this.state.postData.length*25) + "%"}}>
                            {this.makeGoods()}
                        </div>
                    </div>
                    <div className="arrow left" onClick={this.leftClick}><Arrow/></div>
                    {pad}
                </StyleLaptop>
            )  
        }
        return(
            <StyleLaptop className={classname} >
                {pad}
                {this.makeGoods()}
                {pad}
            </StyleLaptop>
        )
    }
    makeGoods = () => {
        const all=JSON.parse(this.props.data)
        return all.map((v, i) => {
            return (
                <div className="main-box" key={i}>
                    <GoodPostCart data={v} />
                </div>
            )
        })
    }
    mobileRender(){
        return(
            <StyleMobile>
                <div className="arrow right"><Arrow click={this.rightClick}/></div>
                <div className="container-scroll" ref={this.refScroll}>
                    <div className="main-scroll" style={{width: (this.state.postData.length*80) + "vw"}}>
                        {this.makeGoods()}
                    </div>
                </div>
                <div className="arrow left"><Arrow click={this.leftClick}/></div>
            </StyleMobile>
        )
    }

    render(){
        if(!this.state.sending){
            if(window.innerWidth < 850 ){
                return this.mobileRender()
            }else{
                return this.laptopRender()
            }
        }
        return <Loading/>
    }
}
export default RibbonBlogPostGood